import recruiter_profile_widget_0 from "file:///home/wldocker/wl-cms/sites/modules/recruiter-profile-widget/ui/src/recruiter-profile-widget.js";



import recruiter_profile_widget_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/recruiter-profile-widget/ui/src/recruiter-profile-widget.scss";recruiter_profile_widget_0();